export interface CatalogItem {
  id: string;
  name: string;
  meta: string;
  price: number;
}

export interface CartItem extends CatalogItem {
  qty: number;
}

export type TicketStatus = "active" | "awaiting" | "walk-in";

export interface PosClient {
  id: string;
  name: string;
}

export interface PosTicket {
  id: string;
  number: number;
  client: PosClient | null;
  cart: CartItem[];
  tipPercent: number;
  status: TicketStatus;
  /** Set when checkout is completed; allows closing the tab without a warning. */
  paid: boolean;
}

export const DEFAULT_TAX_RATE = 0.08875;

export const TIP_PRESETS = [0, 5, 10, 25] as const;

export function normalizeTipPercent(percent: number): number {
  if (!Number.isFinite(percent)) {
    return 0;
  }
  return Math.min(100, Math.max(0, percent));
}
